/**
 * Expand and collapse elements
 * @module app/components/DropdownAdapter
 */
import jQuery from 'jquery';
import MobileDetect from './MobileDetect';

/**
 * isDevice
 *
 * @returns {{ Android: , BlackBerry: , iOS:, Windows:, any: }}
 *
 * @private
 */
var isDevice = MobileDetect.init;

/**
 * Stores references to expanded elements so we don't have to use slow methods like .hasClass to get the state
 * @type {Array}
 */
var expanded = [];

/**
 * Expands the target element and adds expanded state to sender
 *
 * @param   {Object} sender DOM element that triggers the action
 * @param   {Object} element DOM element that receives the action
 *
 * @returns {void}
 *
 * @private
 */
var expand = function (sender, element) {
    jQuery(sender)
        .addClass('-expanded').attr('aria-expanded', true).parent().addClass('-opened');
    element.slideDown(200, function () {
        var $this = jQuery(this);
        $this.addClass('-expanded').attr('aria-expanded',true).parent().addClass('-opened');
    });

};

/**
 * Collapses the target element and removes expanded state from sender
 *
 * @param {Object} sender DOM element that triggers the action
 * @param {Object} element DOM element that receives the action
 *
 * @returns {void}
 *
 * @private
 */
var collapse = function (sender, element) {
    jQuery(sender)
        .removeClass('-expanded').attr('aria-expanded', false).parent().removeClass('-opened');
    element.slideUp(200, function () {
        var $this = jQuery(this);
        $this.removeClass('-expanded').attr('aria-expanded',false).parent().removeClass('-opened');
        /**
         * Remove the style attribute and clear up if data-cleanup is defined
         * When traversing through breakpoints it can cause issues with hidden
         * menus that should be shown and vice versa.
         */
        if ($this.data('cleanup') !== undefined) {
            $this.removeAttr('style');
        }
    });
};

/**
 * Delegates an action to execute based on current state
 *
 * @param sender
 * @param id
 *
 * @returns {void}
 *
 * @private
 */
var toggle = function (sender, id) {

    var element = jQuery('[data-toggle-receive="' + id + '"]');

    /**
     * Check if the receiving element is in a group or not
     *
     * @param element {Object} DOM element to check if grouped
     *
     * @returns {boolean}
     *
     * @private
     */
    var isGroup = function (element) {

        return element.data('toggle-group') !== undefined;
    };

    /**
     * Returns true or false based on the conditions set in
     * SBK-979: if we're on a mobile device and using the market
     * collections menu, do not collapse siblings (groups)
     *
     * @param   {Object}  element jQuery object
     *
     * @returns {Boolean}         Returns true if conditions are met
     *
     * @private
     */
    var shouldCollapseGroups = function (element) {

        return element.data('toggle-group') === 'marketmenu' && isDevice().any();
    };

    /**
     * Processes a group of dropdowns
     *
     * @returns {void}
     *
     * @private
     */
    var processGroup = function () {

        /**
         * Process dropdown status
         *
         * @returns {void}
         *
         * @private
         */
        var processStatus = function () {

            if (element.hasClass('-expanded')) {
                collapse(sender, element);
            } else {
                expand(sender, element);
            }
        };

        // Check if dropdown is part of a group where only one is shown at a time
        if (isGroup(element) && !shouldCollapseGroups(element)) {
            var groupId = element.data('toggle-group'),
                groupSender = jQuery('[data-toggle-send][data-toggle-group="' + groupId + '"]');

            collapse(groupSender,
                jQuery('[data-toggle-receive][data-toggle-group="' + groupId + '"]')
                    .not(element));
        }

        processStatus();
    };

    processGroup();
};


/**
 * Removes tooltip after click on dropdown
 *
 * @returns {void}
 *
 * @private
 */
function handleTooltip() {
    const tooltipContainers = document.querySelectorAll('tooltip-item');

    tooltipContainers.forEach(tooltipContainer => {
        const tooltip = tooltipContainer.shadowRoot.querySelector('.tooltip');

        tooltip && tooltip.remove();
    });
}

/**
 * Binds event handlers
 *
 * @returns {void}
 *
 * @private
 */
var bindEvents = function () {

    jQuery('#main, #odds-format-filter, #desktop-sidebar-az, #subheader-desktop')
        .off('click.dropdownAdapterSend keypress.dropdownAdapterSend')
        .on('click.dropdownAdapterSend keypress.dropdownAdapterSend', '[data-toggle-send]', function (e) {
            var id = jQuery(this)
                .data('toggle-send');

            handleTooltip();
            // toggle current [data-toggle-send] element
            toggle(this, id);
            e.preventDefault();
            e.stopImmediatePropagation();
        });
};

/**
 * Init a dropdown menu
 *
 * @param   {Number} index   Index
 * @param   {Object} element jQuery element
 *
 * @returns {void}
 *
 * @private
 */
var initDropdown = function (index, element) {

    var id = jQuery(element).attr('data-toggle-receive');

    if (jQuery(element).hasClass('-expanded')) {
        expanded[id] = true;
    }
};

/**
 * Methods to be public
 *
 * @type {Object}
 */
var api = {

    /**
     * Sets up drop Down / toggle menus
     *
     * @returns {void}
     *
     * @public
     */
    init: function () {

        var selectorsContainers = '#contentarea, #in-play-schedule-sport-filter, #prefooter, ' +
            '#coupons_canvas, #account-section';
        var selectors = '#localnavigation-affix-top, #localNavigationMobileSports';

        jQuery.each(jQuery(selectorsContainers).find(('[data-toggle-receive]')), initDropdown);

        jQuery.each(jQuery(selectors), initDropdown);

        bindEvents();
    },
};

export default api;
